<div class="mobile-avatar" [style.background-image]="'url(' + dataURI() + ')'"
	[ngClass]="sizeClass()">
</div>